module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "orders-information"
  }, [_c('figure', {
    staticClass: "store-img"
  }, [_c('img', {
    attrs: {
      "src": "http://rem3rch-back.snap.viseo.com/uploads/components/small/20171004004437470.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "store-contact"
  }, [_c('div', {
    staticClass: "store store-adress"
  }, [_c('span', {
    staticClass: "label label-region"
  }, [_vm._v("Champs elysees")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("125 avenue des champs elysees")]), _vm._v(" "), _c('span', {
    staticClass: "label label-country"
  }, [_vm._v("France")])]), _vm._v(" "), _c('div', {
    staticClass: "store store-phone"
  }, [_c('span', [_vm._v("+44 0376 124578")])]), _vm._v(" "), _c('div', {
    staticClass: "store store-status"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Store status:")]), _vm._v(" "), _c('span', [_vm._v("Approved")])]), _vm._v(" "), _c('div', {
    staticClass: "store store-email"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Contact:")]), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v("toto.tata@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "store store-type"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Display type: ")]), _vm._v(" "), _c('span', [_vm._v("Hybrid 5 bays")])]), _vm._v(" "), _c('div', {
    staticClass: "store-action"
  }, [_c('button', {
    staticClass: "btn-orders"
  }, [_vm._v("view planogram")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f922850","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-information.vue
// module id = 3312
// module chunks = 0